import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './ProductShowcase.css';

const ProductShowcase = () => {
  const { t } = useTranslation();
  const products = [
    {
      id: 1,
      name: t('products.items.kaerhei.name'),
      description: t('products.items.kaerhei.description'),
      image: '/images/卡尔黑.jpg',
      features: t('products.items.kaerhei.features', { returnObjects: true })
    },
    {
      id: 2,
      name: t('products.items.nansilafubai.name'),
      description: t('products.items.nansilafubai.description'),
      image: '/images/南斯拉夫白.jpg',
      features: t('products.items.nansilafubai.features', { returnObjects: true })
    },
    {
      id: 3,
      name: t('products.items.shaanna.name'),
      description: t('products.items.shaanna.description'),
      image: '/images/莎安娜.jpg',
      features: t('products.items.shaanna.features', { returnObjects: true })
    },
    {
      id: 4,
      name: t('products.items.yunduolahui.name'),
      description: t('products.items.yunduolahui.description'),
      image: '/images/云朵拉灰.jpg',
      features: t('products.items.yunduolahui.features', { returnObjects: true })
    },
    {
      id: 5,
      name: t('products.items.xiandaihui.name'),
      description: t('products.items.xiandaihui.description'),
      image: '/images/现代灰.jpg',
      features: t('products.items.xiandaihui.features', { returnObjects: true })
    },
    {
      id: 6,
      name: t('products.items.yuduhui.name'),
      description: t('products.items.yuduhui.description'),
      image: '/images/鱼肚灰.jpg',
      features: t('products.items.yuduhui.features', { returnObjects: true })
    }
  ];

  const productRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    productRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      productRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <section className="product-showcase">
      <h2 className="section-title">{t('products.title')}</h2>
      <div className="products-container">
        {products.map((product, index) => (
          <div
            key={product.id}
            ref={(el) => (productRefs.current[index] = el)}
            className="product-card"
          >
            <div className="product-image">
              <img src={product.image} alt={product.name} />
            </div>
            <div className="product-info">
              <h3>{product.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductShowcase; 